import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  HttpLink,
} from "@apollo/client";

const link = ApolloLink.from([
  new ApolloLink((operation, forward) => {
    operation.variables = {
      ...operation.variables,
      __typename: undefined,
    };
    return forward(operation);
  }),
  new HttpLink({
    uri: process.env.REACT_APP_GRAPHQL_URL,
  }),
]);

const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
});

export default client;
